import { render, staticRenderFns } from "./topicinfo.vue?vue&type=template&id=18880230&scoped=true"
import script from "./topicinfo.vue?vue&type=script&lang=js"
export * from "./topicinfo.vue?vue&type=script&lang=js"
import style0 from "./topicinfo.vue?vue&type=style&index=0&id=18880230&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18880230",
  null
  
)

export default component.exports